import classes from './MainNavigation.module.scss'
import Link from 'next/link'
import dynamic from 'next/dynamic';
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'

const NavigationUtilities = dynamic(() => import('./NavigationUtilities'))
const PrimaryNavigation = dynamic(() => import('./PrimaryNavigation'))

const MainNavigation = ({ props }) => {
  const router = useRouter()
  const isChooseYourPlanPage = router.pathname === '/pages/choose-your-plan'
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    if (!isChooseYourPlanPage) return

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }

    window.addEventListener('scroll', handleScroll)
    // Check initial scroll position
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [isChooseYourPlanPage])

  return (
    <div
      className={[
        classes.mainNavigation,
        classes.mainNavContainer,
        isChooseYourPlanPage ? classes['choose-your-plan'] : '',
        isChooseYourPlanPage && isScrolled ? classes['scrolled'] : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <PrimaryNavigation props={props} classes={classes} />
      <div className={classes.navLogo}>
        <div className={classes.navLogoContainer}>
          <Link href="/">
            <Image
              src={props.logo.asset.url}
              fill
              alt={props.logo.asset.alt || 'Logo'}
              priority
              sizes="(max-width: 768px) 80px, 170px"
              style={{ objectFit: 'contain' }}
            />
          </Link>
        </div>
      </div>
      <NavigationUtilities props={props} classes={classes} />
    </div>
  )
}

export default MainNavigation
